<template>
    <Sheet v-loading="loading.actions['role']">
        <h2>{{routeTitle}}</h2>
        <el-button
                @click="onEnterInsert"
                icon="el-icon-plus"
                size="mini"
                type="primary"
        >
            新增
        </el-button>
        <el-button
                @click="refresh"
                icon="el-icon-refresh"
                size="mini"
        >
            重新整理
        </el-button>
        <el-row
                :gutter="16"
        >

            <el-col
                    :span="12"
            >
                <h4>角色列表</h4>
                <el-table
                        :data="pagedData"
                        :stripe="true"
                        empty-text="無表單"
                        height="500px"
                        row-key="id"
                        size="small"
                >
                    <el-table-column
                            label="ID"
                            prop="id"
                    ></el-table-column>
                    <el-table-column
                            label="名稱"
                            prop="name"
                    ></el-table-column>
                    <el-table-column
                            label="停用?"
                            prop="disabled"
                    >
                        <template #default="{row}">
                            {{row.disabled ? '是': '否'}}
                        </template>
                    </el-table-column>
                    <el-table-column>
                        <template #default="{row}">
                            <el-button
                                    @click="onEnterEdit(row)"
                                    icon="el-icon-edit"
                                    size="mini"
                                    type="primary"
                            ></el-button>
                            <el-button
                                    @click="onRemove(row)"
                                    icon="el-icon-delete"
                                    size="mini"
                                    type="danger"
                                    v-if="!row.isDefault"
                            ></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        :current-page.sync="currentPage"
                        :page-size="pageSize"
                        :total="roles.length"
                        @current-change="page => pageChange(page, pagedData)"
                        background
                        layout="total, prev, pager, next"
                        style="margin-top: 10px;"
                ></el-pagination>
            </el-col>
            <el-col
                    :span="12"
            >
                <h4>權限</h4>
                <template v-if="current">
                    <el-form :model="current" ref="form">
                        <el-form-item

                                :rules="[{required:true, message:'請輸入名稱'}]"
                                label="名稱"
                                prop="name"
                        >
                            <el-input
                                    placeholder="請輸入名稱"
                                    v-model="current.name"
                                    ref="name"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                                label="停用嗎?"
                                prop="disabled"
                        >
                            <el-checkbox
                                    v-model="current.disabled"
                            ></el-checkbox>
                        </el-form-item>
                    </el-form>
                    <div style="max-height: 600px; overflow-y: auto; ">
                        <el-tree
                                :data="nodes"
                                default-expand-all
                                node-key="key"
                                ref="tree"
                                show-checkbox
                                style="background-color: azure"
                        ></el-tree>
                    </div>

                    <div style="width: 100%; text-align: right; background-color: azure; padding: 10px 0px">
                        <el-button
                                @click="onSubmit"
                                size="mini"
                                style="margin-right: 5px;"
                                type="primary"
                        >
                            {{isInsertMode ? '加入' : '更新設定'}}
                        </el-button>
                    </div>
                </template>

            </el-col>
        </el-row>
    </Sheet>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import routeTitleMixin from './routeTitleMixin';
    import pagingMixin from '../pagingMixin';
    import nodesMixin from './nodesMixin';
    import {join} from '../utilities';

    export default {
        name: 'RolesManage',
        mixins: [routeTitleMixin, pagingMixin, nodesMixin],
        data: () => ({
            current: null,
            isInsertMode: false
        }),
        computed: {
            ...mapState(['loading']),
            ...mapState('role', ['roles']),
            ...mapState('menu', ['menus']),
        },
        methods: {
            ...mapActions('role', {
                getAll: 'getRolesAction',
                insert: 'addRoleAction',
                remove: 'removeRoleAction',
                update: 'updateRoleAction',
            }),
            ...mapActions('menu', {
                getMenus: 'getMenusAction',
            }),

            async onEnterEdit(row) {
                this.current = {...row};
                const checked = join(
                    this.current.rightSets, this.leave,
                    l => l.menuId, r => r.id, (_, r) => r.menuId);
                this.isInsertMode = false;
                const self = this;
                this.$nextTick(() => {
                    const tree = self.$refs['tree'];
                    const nameIpt = self.$refs['name'];
                    tree.setCheckedKeys([...checked]);
                    nameIpt.focus();
                });
            },

            onEnterInsert() {
                this.current = {
                    name: '請輸入名稱',
                    rightSets: [],
                    disabled: false
                };
                this.isInsertMode = true;
                const self = this;
                this.$nextTick(() => {
                    const tree = self.$refs['tree'];
                    const nameIpt = self.$refs['name'];
                    tree.setCheckedKeys([]);
                    nameIpt.focus();
                });
            },

            async onSubmit() {
                const current = this.$refs['form'];
                const tree = this.$refs['tree'];
                const rightSets = [
                    ...tree.getCheckedNodes(),
                    ...tree.getHalfCheckedNodes()]
                    .filter(r => !r.isRoot)
                    .map(r => ({roleId: current.id, menuId: r.raw.id}));

                current.validate(async valid => {
                    if (valid) {
                        const action = this.isInsertMode ? 'insert' : 'update';
                        const {success} = await this[action]({
                            ...this.current,
                            rightSets
                        });

                        if (success) {
                            this.$message({
                                type: 'success',
                                message: this.isInsertMode ? '新增成功' : '異動成功'
                            });
                        } else {
                            this.$message({
                                type: 'danger',
                                message: '操作失敗，請重試一次'
                            });
                        }
                        this.reset();
                    } else {
                        this.$message({
                            type: 'warning',
                            message: '驗證失敗，請檢查*欄位'
                        });
                    }
                });
            },

            async onRemove({id}) {
                try {
                    await this.$confirm('確定要刪除嗎?', {
                        type: 'danger',
                    });
                    const {success} = await this.remove(id);
                    if (success) {
                        this.$message.success('刪除成功');
                    } else {
                        this.$message.warning('刪除失敗，請重試一次');
                    }
                } catch (e) {
                    if (e !== 'cancel') {
                        this.$message({
                            type: 'error',
                            message: '發生錯誤，請重試一次!'
                        });
                    }
                }
            },

            reset() {
                this.current = null;
                this.isInsertMode = false;
            },

            async refresh() {
                await this.getAll();
                this.reset();
            }
        },

        watch: {
            roles(current) {
                this.pagedData = this.pageData(current, 1);
                this.currentPage = 1;
            }
        },

        async created() {
            await this.getAll();
            await this.getMenus();
        }
    }
</script>

<style scoped>

</style>